<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <el-button type="primary" :loading="loading" size="small" @click="handleSubmit">
        同意
      </el-button>
      <el-button v-if="isShowInternationalServiceOrders!==1" type="danger" :loading="rejectLoading" size="small" @click="handleReject">
        驳回
      </el-button>
    </div>
  </div>
</template>
<script type="es6">
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    rejectLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowInternationalServiceOrders: 0// 是否是国际服务订单,0国内,1国际,用于控制电源线字段是否显示
    };
  },
  methods: {
    // 提交
    handleSubmit () {
      this.$emit('handleSubmit');
    },
    // 驳回
    handleReject () {
      this.$emit('handleReject');
    }
  },
  mounted () {
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
  }
};
</script>
